export const cilArrowThickRight = ["24 24","<path d='M11.92 23.25h-1.794l-0-6.747h-9.376v-9h9.375l-0-6.751 1.813 0.002 11.248 11.261zM2.25 15.003h9.376l0 6.422 9.438-9.412-9.439-9.45 0 6.44h-9.375z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-arrow-thick-right.js
// module id = null
// module chunks = 